import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';
import AppService from 'App/legacy/AppService';
import type { ContactRelation, ContactWithRelations } from 'App/resources/ContactRelation';

const openAdapter = asyncModalAdapter({
	upModalName: 'editContactRelation',
	openModalName: 'EditContactRelation',
	featureFlag: 'REACT_CONTACT_CARD',
	rejectOnEmpty: false
});

// The Angular fallback modal reads customerId from $modalParams — injected here so callers don't have to
export const openEditContactRelation = (props: { contact: ContactWithRelations; relation?: ContactRelation }) =>
	openAdapter({ ...props, customerId: AppService.getCustomerId() });
